import type { ReactElement } from 'react';
import { Presentation, presentations } from '@presentations/presentations';
import { loadSlides } from './load-slides';

export { presentations };
export type { Presentation };

export const loadPresentation = async (folder: string): Promise<(() => ReactElement)[]> => {
  return await loadSlides(folder);
};
